<div class="container">
   <div class="row justify-content-center body-centered">
      <div class="col-lg-10">
            <div class="row g-0 ">
               <!-- Left Section - Company Logos -->
               <div class="col-md-6 d-flex align-items-center justify-content-center">
                  <div class="container-fluid puzzle-board w-100">
                     <!-- Row 1 -->
                     <div class="row g-0 justify-content-center">
                        <div class="col-4 col-md-2">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Haul Express</div>
                           </div>
                        </div>
                        <div class="col-4 col-md-auto">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Cargo Masters</div>
                           </div>
                        </div>
                        <div class="col-4 col-md-2">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Swift Transit</div>
                           </div>
                        </div>
                        <div class="col-6 col-md">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">📦 Rent This Space</div>
                           </div>
                        </div>
                        <div class="col-6 col-md-2">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Heavy Trailers</div>
                           </div>
                        </div>
                     </div>
                     <!-- Row 2 -->
                     <div class="row g-0 justify-content-center">
                        <div class="col-3 col-md-auto">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">📢 Billboard Ad</div>
                           </div>
                        </div>
                        <div class="col-3 col">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Fast Movers</div>
                           </div>
                        </div>
                        <div class="col-3 col-md-3">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Quick Transport</div>
                           </div>
                        </div>
                        <div class="col-3 col-md-auto">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Load your 🚛</div>
                           </div>
                        </div>
                     </div>
                     <!-- Row 3 -->
                     <div class="row g-0 justify-content-center">
                        <div class="col-6 col-md-2">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">USA Movers</div>
                           </div>
                        </div>
                        <div class="col-6 col-md-auto">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">📞 Get Listed</div>
                           </div>
                        </div>
                        <div class="col-4 col-md">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Cargo Express</div>
                           </div>
                        </div>
                        <div class="col-4 col-md-2">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Swift Movers</div>
                           </div>
                        </div>
                        <div class="col-4 col-md-auto">
                           <div class="text-box puzzle-connected">
                              <div class="text-content">Netaji Trasport</div>
                           </div>
                        </div>
                     </div>
                     <div class="row g-0 justify-content-center">
                        <div class="col-auto">
                           <a href="/partners" aria-label="View partners"
                              class="d-inline-flex align-items-center text-decoration-none">
                              <i class="fa-solid fa-handshake fa-sm me-2" style="color: orange;" aria-hidden="true"></i>
                              <span class="credits">Partners</span>
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
               <!-- Vertical Divider -->
               <div class="col-md-1 d-md-flex justify-content-center">
                  <div class="vertical-divider"></div>
               </div>
               <!-- Right Section - Registration Form -->
               <div class="col-md-5">
                  <app-registration></app-registration>
               </div>
            </div>
         </div>
   </div>
</div>